import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  dealDetailsWrapper: {
    border: '1px solid #EFEFEF',
    borderRadius: '12px',
    padding: '8px 12px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    backgroundColor: '#FFF',
    '&:hover': {
      border: '1px solid #8E8E8F',
    },
    '& .circle': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      backgroundColor: '#F0EEFC',
    },
  },
  dealMainInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    '& .main': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px',
      fontSize: '9px',
      fontWeight: '700',
      lineHeight: '10px',
      '& .dealStatus': {
        display: 'flex',
        padding: '3.5px 4px 2.5px 4px',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '4px',
        backgroundColor: '#ECECEC',
        color: '#1D1D1F',
      },
      '& .dealNumber': {
        color: '#5E5E60',
      },
    },
    '& .dealLink': {
      width: '16px',
      height: '16px',
      cursor: 'pointer',
      '&:hover': {
        paddingLeft: '2px',
      },
    },
  },
  dealAdditionalInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
    '& .dealName': {
      fontSize: '13px',
      fontWeight: '700',
      lineHeight: '16px',
      color: '#1D1D1F',
    },
    '& .dealLinkedBy': {
      display: 'flex',
      flexDirection: 'column',
      '& .dealLinkedByName': {
        fontSize: '11px',
        lineHeight: '14px',
        color: '#1D1D1F',
        '& .badge': {
          fontWeight: '400',
        },
        '& .name': {
          fontWeight: '700',
        },
      },
      '& .dealLinkedByDate': {
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: '10px',
        lineHeight: '14px',
        color: '#5E5E60',
      },
    },
    '& .contacts': {
      display: 'flex',
      gap: '8px',
      '& .avatar': {
        width: '28px',
        height: '28px',
      },
      '& .details': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
        lineHeight: '14px',
        '& .name': {
          color: '#1D1D1F',
          fontSize: '11px',
          fontWeight: '700',
        },
        '& .phone': {
          color: '#5E5E60',
          fontSize: '10px',
          fontWeight: '400',
        },
      },
    },
    '& .linked': {
      display: 'flex',
      justifyContent: 'space-between',
      lineHeight: '14px',
      '& .unit': {
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        fontSize: '10px',
        color: '#1D1D1F',
        '& .status': {
          width: '6px',
          height: '6px',
          backgroundColor: '#357A32',
        },
        '& .linked-unit': {
          fontWeight: '400',
        },
        '& .unit-number': {
          fontWeight: '900',
        },
      },
      '& .unlink': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '4px',
        color: '#5E5E60',
        fontSize: '10px',
        cursor: 'pointer',
        '& .icon': {
          color: '#5E5E60',
        },
        '&:hover': {
          color: '#A31A18',
          '& svg': {
            color: '#A31A18',
          },
        },
      },
    },
  },
}));
